/**
 * @file paddle Live
 * @author FengGuang(fengguang01@baidu.com)
 */

import React from 'react';
import {Button} from 'antd';

import Header from '../../components/header/HeaderWithStore';
import Footer from '../../components/footer/footer';
import Banner from '../../components/banner/Banner';
import useLiveHooks from './LiveHooks';
import LiveCardGroup from './components/live-card/LiveCardGroup';
import LiveCalendar from './components/live-calendar/LiveCalendar';


const Live: React.FC = () => {

    const {
        banner,
        liveCard,
        liveCalendar
    } = useLiveHooks();

    return (
        <div className="page paddle-live-page">
            <Header />
            {!!banner
            && (
                <Banner
                    title={banner.title}
                    subtitle={banner.subtitle}
                >
                    {banner.btns.length > 0
                    && (
                        <div className="paddle-live-page-banner-btn-group">
                            {banner.btns?.map((btn: any) => (
                                <a
                                    key={`${btn.label}${btn.href}`}
                                    href={btn.href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <Button
                                        type="primary"
                                        size="large"
                                        className="paddle-live-page-banner-btn"
                                    >
                                        {btn.label}
                                    </Button>
                                </a>
                            ))}
                        </div>
                    )}
                </Banner>
            )}
            <div className="paddle-live-page-content">
                {!!liveCard
                && (
                    <div className="paddle-live-content">
                        <LiveCardGroup
                            {...liveCard}
                        />
                    </div>
                )}

                {!!liveCalendar
                && (
                    <div className="paddle-live-content">
                        <LiveCalendar
                            {...liveCalendar}
                        />
                    </div>
                )}
            </div>
            <Footer />
        </div>
    );
};

export default React.memo(Live);
